import makeRequest from 'utils/makeRequest'
import { PUBLIC_ENDPOINTS } from 'config/apiEndpoints'
import IVisit from 'models/IVisit'
import IResponseApi from 'models/IResponseApi'

export const restaurantInfoService = {
  getRestaurantInfo: async (slug: string): Promise<IResponseApi> => {
    try {
      const url = `${PUBLIC_ENDPOINTS.GetRestaurantInfo}?slug=${slug}`
      const response: IResponseApi = await makeRequest('GET', url)

      return response
    } catch (error) {
      throw new Error('Get restaurant info failed')
    }
  },
  getAnnouncement: async (slug: string): Promise<IResponseApi> => {
    try {
      const url = `${PUBLIC_ENDPOINTS.GetAnnouncement}?slug=${slug}`
      const response: IResponseApi = await makeRequest('GET', url)

      return response
    } catch (error) {
      throw new Error('Get restaurant announcement failed')
    }
  },
  visit: async (visitBody: IVisit): Promise<IResponseApi> => {
    try {
      const response: IResponseApi = await makeRequest(
        'POST',
        PUBLIC_ENDPOINTS.Visit,
        JSON.stringify(visitBody),
        'application/json'
      )

      return response
    } catch (error) {
      throw new Error('Sending Visit Failed')
    }
  },
}
